module.exports = __webpack_public_path__ + "img/rosario_winter.fca2532f.svg";